// extracted by mini-css-extract-plugin
export default {"loginPage":"styles_loginPage__kYsgg","mainContent":"styles_mainContent__n-t7F","subTitle":"styles_subTitle__yAtQ9"};